// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-popver .ant-popover-inner {\n  background: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.color-popver .ant-popover-inner-content {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
